// extracted by mini-css-extract-plugin
export default {"proContainer":"styles_proContainer__ir7su","proText":"styles_proText__xxDf0"};